module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copyrightaa"
  }, [_c('a', {
    attrs: {
      "id": "page_iv"
    }
  }), _vm._v("Cataloging-in-Publication Data has been applied for and"), _c('br'), _vm._v("may be obtained from the Library of Congress."), _c('br'), _vm._v("ISBN 978-0-8109-8921-4")]), _vm._v(" "), _c('p', {
    staticClass: "copyrighta"
  }, [_vm._v("Copyright © 2010 William Buckholz")]), _vm._v(" "), _c('p', {
    staticClass: "copyrighta"
  }, [_vm._v("Published in 2010 by Abrams Image, an imprint of ABRAMS. All rights reserved."), _c('br'), _vm._v("No portion of this book may be reproduced, stored in a retrieval system, or transmitted"), _c('br'), _vm._v("in any form or by any means, mechanical, electronic, photocopying, recording,"), _c('br'), _vm._v("or otherwise, without written permission from the publisher.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrighta"
  }, [_vm._v("Printed and bound in U.S.A."), _c('br'), _vm._v("10 9 8 7 6 5 4 3 2 1")]), _vm._v(" "), _c('p', {
    staticClass: "copyrighta"
  }, [_vm._v("Abrams Image books are available at special discounts when purchased in quantity"), _c('br'), _vm._v("for premiums and promotions as well as fundraising or educational use."), _c('br'), _vm._v("Special editions can also be created to specification.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("For details, contact specialmarkets@abramsbooks.com, or the address below.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightaa"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/pub1.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aefbb34e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/copyright.vue
// module id = 66
// module chunks = 0